/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {get} from './api-calls';
import {IUserInsightsDto} from '../dtos/IInsightsDto';
import {getCurrentTimeZone} from '../utils/date-time-utils';
export const getUserInsights = (userId: string): Promise<IUserInsightsDto> => {
  const timeZone = getCurrentTimeZone();
  return get(`/userInsights/?Id=${userId}&TimeZoneId=${timeZone}`);
};
